import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Arrow from "../../../../assets/images/arrow.png";
import { useTranslation } from "react-i18next";
import CustomInput from "../../../CustomComponents/FormInputs";
import Card from "../../../CustomComponents/Card";
import addLineBreaks from "../../../../utils";
import {
  GetApiHeadersWithOutBearer,
  GetRequest,
  PostRequest,
} from "../../../../network/NetworkUtils";
import {
  EMAIL_OTP_GENERATION,
  STATUS_SUCCESS_CODE,
  META_DATA_POLICIES,
  EMAIL_OTP_GENERATION_NEW,
  SMI_ONE_CREATE_PASSWORD,
} from "../../../../network//URLConstants";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../CustomComponents/Loader";
import {
  appTheme,
  generateRegexExpression,
  generateRegexExpression1,
  retrieveData,
} from "../../../../helpers/utils/Utils";
import { fetchConfigarationData } from "../../../../helpers/utils/Utils";
import { useKeyDown } from "../../../../hooks/useKeyDown";
import { displayErrorMessage } from "../../../../utils";
import logFirebaseEvents from "../../../LogFirebaseEvents";
import CustomTextInput from "../../../CustomComponents/CustomtextInput";
import BlueTick from "../../../../assets/smi-kudzu-images/blue_tick.png"
const appConfigData = await fetchConfigarationData();
// const appConfigData = await fetchConfigarationData();
const CreatePassword = ({
  openPersonalInformationClick,
  email,
  openCreatePassword,
}) => {
  const { t } = useTranslation();
  const appConfigData = useSelector((state) => state.appConfigData);
  //  const deviceId = useSelector(state => state.deviceId);
  const SubTittleStylesModal =
    "font-serif-pro lg:text-[31px] md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px] md:leading-[33px] sm:leading-[29px] leading-[31px] font-normal sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)]";
  const userId = useSelector((state) => state.userId);
  const [password, setPassword] = useState("");
  //  const [repeatPassword, setrepeatPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isMinMax, setIsMinMax] = useState(false);
  const [isNumeric, setIsNumeric] = useState(false);
  const [isAlpha, setIsAlpha] = useState(false);
  const [isLowerCase, setIsLowerCase] = useState(false);
  const [isUpperCase, setIsUpperCase] = useState(false);
  const [isSpecialChar, setIsSpecialChar] = useState(false);
  const [policyCriteria, setPolicyCriteria] = useState({});
  const [policyRules, setPolicyRules] = useState("");
  const regexpression = generateRegexExpression(policyCriteria.PolicyTemplate);
  const [isNewPasswordValid, setIsNewPasswordValid] = useState(false);
  const [isRepeatPasswordValid, setIsRepeatPasswordValid] = useState(false);
  const newPasswordRef = useRef(null);
  const repeatPasswordRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isShowPolicyRules, setIsShowPolicyRules] = useState(false);
  let policyIndex = 0;
  const providerIdentifier = useSelector((state) => state.providerIdentifier);
  const issuerURL = useSelector((state) => state.issuerURL);
  const emailFromProvider = useSelector((state) => state.emailFromProvider);
  const isB2c = useSelector((state) => state.preferredIdentity);
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const signUpEnteredEmail = useSelector((state) => state.signUpEmail);
  const smiOneUserId = useSelector(state => state.smiOneKudzuResponseData.userId);
  const dispatch = useDispatch();
    
  const signUpkudzuPlusTrue = useSelector(
    (state) => state.isSignUpKudzuplusTrue
  );
  const appThemeData = appTheme(signUpkudzuPlusTrue);

  const schema = yup.object().shape({
    newPassword: yup
      .string()
      .required(t("Password_REQUIRED"))
      .matches(
        regexpression,
        t("PASSWORD_VALIDATION")
      ),
    repeatPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], t("repeat_password_error_msg"))
      .required(t("confirm_password_required")),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    getValues,
    setError,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const handlePasswordChange = () => {
    const password = getValues("newPassword");
    const repeatPassword = getValues("repeatPassword");

    // Update policy rule indicators
    const minMaxRegex = generateRegexExpression1("MinMax", policyCriteria?.PolicyTemplate);
    const numericRegex = generateRegexExpression1("Numeric", policyCriteria?.PolicyTemplate);
    const alphaRegex = generateRegexExpression1("Alpha", policyCriteria?.PolicyTemplate);
    const lowercaseRegex = generateRegexExpression1("Lowercase", policyCriteria?.PolicyTemplate);
    const uppercaseRegex = generateRegexExpression1("Uppercase", policyCriteria?.PolicyTemplate);
    const specialCharRegex = generateRegexExpression1("Special", policyCriteria?.PolicyTemplate);

    setIsNumeric(numericRegex.test(password));
    setIsMinMax(minMaxRegex.test(password));
    setIsAlpha(alphaRegex.test(password));
    setIsLowerCase(lowercaseRegex.test(password));
    setIsUpperCase(uppercaseRegex.test(password));
    setIsSpecialChar(specialCharRegex.test(password));
    setIsNewPasswordValid(regexpression.test(password));

    if (repeatPassword) {
      setIsRepeatPasswordValid(password === repeatPassword);
      trigger("repeatPassword");
    }

    dispatch({ type: "SMI_ONE_NEW_CREATED_PASSWORD", payload: { smiOneNewCreatedPassword: password } });
    setPassword(password);
  };

  const handleRepeatPasswordChange = () => {
    const repeatPassword = getValues("repeatPassword");
    const password = getValues("newPassword");
    setIsRepeatPasswordValid(password !== "" && repeatPassword === password);
  };

  useEffect(() => {
    getPasswordPolicy();
  }, [userId]);

  const getPasswordPolicy = async () => {
    setIsLoading(true);
    try {
      const applicationId = appConfigData.APP_CLIENT_ID;
      const url = `${META_DATA_POLICIES}language=en&applicationid=${applicationId}&avn=1.0.0&isNew=true`;
 
      const deviceId = await retrieveData("updatedDeviceId");
      const headers = await GetApiHeadersWithOutBearer(deviceId);
 
      const response = await GetRequest(url, headers);
      const responseObj = JSON.parse(response);
      if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
        const policyObj = responseObj.Response?.PasswordPolicy;
        setPolicyCriteria(policyObj);
        setPolicyRules(policyObj.PolicyRules);
        setIsShowPolicyRules(true);
        setIsLoading(false);
        // setErrorMessage('');
        clearErrors();
      } else {
        setIsLoading(false);
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        // setErrorMessage(displayText);
        setError("repeatPassword", {
          type: "manual",
          message: displayText,
        });
        setTimeout(() => {
          clearErrors();
          // setErrorMessage('');
        }, 3000);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
 

  async function createPassword() {
    const deviceId = await retrieveData("updatedDeviceId");
    let headers = await GetApiHeadersWithOutBearer(deviceId);

    var object = {
      applicationId: appConfigData.CLIENT_ID,
      language: "en",
      username: email,
      password: password,
    };

    if (providerIdentifier != null && providerIdentifier != undefined) {
      object.issuerURL = issuerURL;
      object.socialLoginEmail = emailFromProvider;
    }
    if (isFromSmiOne) {
      var url = SMI_ONE_CREATE_PASSWORD(smiOneUserId)
    }else {
      var url = EMAIL_OTP_GENERATION_NEW(isB2c) + userId + "/validate";

    }
    setIsLoading(true);

    var response = await PostRequest(url, object, headers);

    var responseObj = JSON.parse(response);
    if (responseObj.ResponseCode === STATUS_SUCCESS_CODE) {
      logFirebaseEvents(
        "Create_Password",
        "Create_Password_Continue_Cliked",
        "Create_Password_Continue_Cliked",
        "",
        ""
      );
      openCreatePassword(password);
      openPersonalInformationClick();
      // openPatriotActClick();
      setErrorMessage("");
      clearErrors();
    } else {
      var arrMessages = responseObj.Messages;
      setIsLoading(false);
      var message = arrMessages[0];
      var displayText = message.DisplayText;
      // setErrorMessage(displayText);
      setError("repeatPassword", {
        type: "manual",
        message: displayText,
      });
      // setTimeout(() => {
      //   setErrorMessage('');
      // }, 3000);
    }
  }


  return (
    <div className="sm:px-[6%] md:py-10 sm:py-12 flex flex-wrap sm:flex-nowrap scroll-mt-0">
      <Card
        cardHeight={"auto"}
        isWhiteForSignup={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={"--modalcard-bg"}
        heading={
          <>
            <span
              className="font-serif-pro text-[#2965FB] sm:text-[var(--signup-flow-heading-text)] lg:text-[31px]
             md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px]
              md:leading-[33px] sm:leading-[29px] leading-[31px]"
            >
              {t("create_password_heading1")}
            </span>
            <span
              className="font-serif-pro sm:text-[var(--text-clr-secondary)] text-[var(--text-clr-secondary3)] lg:text-[31px]
             md:text-[26px] sm:text-[22px] text-[25px] lg:leading-[38px]
              md:leading-[33px] sm:leading-[29px] leading-[31px]"
            >
              {t("create_password_heading2")}
            </span>
          </>
        }
        subheading={addLineBreaks(
          t("create_password__subheading3"),
          SubTittleStylesModal
        )}
        Cardcaption={t("create_password__caption")}
        header={true}
        footer={true}
        CardRadius={true}
        isLogo={isFromSmiOne ? true  : false}
      >
        <div className="flex flex-col mt-20">
          {
            isFromSmiOne && (
              <>
                        <p
            className="font-hanken-grotesk text-[#929394] 
            uppercase lg:text-[13px] md:text-[12px] sm:text-[12px] text-[13px]
            font-[600] tracking-[2px] 
          "
          >
            {"Email Adress"}
          </p>
              <div className="flex items-center justify-between pt-6 md:pb-[1rem]">
<p
    className="font-hanken-grotesk text-[var(--subHead-clr)]
               lg:text-[14px] md:text-[12px] sm:text-[12px] text-[13px]
               font-[600]"
>
    {signUpEnteredEmail}
</p>
<img src={BlueTick} alt="tick" className="w-[20px] h-[20px]  sm:mr-[-32px] md:mr-[-24px] lg:mr-[13px]" />
</div>
          <hr className="h-[2px] bg-[var(--hr-color)] border-0 rounded" />
          <p className="text-[#4B70B9] pt-2 mb-[3rem] lg:text-[14px] md:text-[14px] sm:text-[10px] text-[11px] font-hanken-grotesk font-[400px] sm:font-medium  md:leading-[20px] leading-[17px]">
            {t("SMI_Password_Email")}
          </p>
              </>
            )
          }

          <CustomInput
            name="newPassword"
            label={t("new_password")}
            placeholder={t("new_password_placeholder")}
            register={register}
            error={errors.newPassword}
            type="password"
            onChange={handlePasswordChange}
            isErrorShow={!!errors.newPassword}
            showValidity={true}
            isAutoFocus={true}
            isPasswordShow={true}
            showPasswordToggle
            isValid={isNewPasswordValid && !errors.newPassword}
            autoFocus={true}
            usernameText = {true}
            ref={newPasswordRef}
          />
          <CustomInput
            name="repeatPassword"
            label={t("repeat_password")}
            placeholder={t("repeat_password_placeholder")}
            register={register}
            showValidity={true}
            error={errors.repeatPassword}
            type="password"
            onChange={handleRepeatPasswordChange}
            isErrorShow={!!errors.repeatPassword}
            isPasswordShow={true}
            showPasswordToggle
            isValid={isRepeatPasswordValid && !errors.repeatPassword}
            ref={repeatPasswordRef}
            onKeyDownFun={(event) => {
              if (event.key == "Enter") {
                event.preventDefault();
                handleSubmit(createPassword)();
              }
            }}
          />
          {   isShowPolicyRules && (
  <ul className="list-disc pl-6 mb-14 lg:text-[18px] md:text-[18px] sm:text-[12px] text-[14px] lg:leading-7 md:leading-[22px] sm:leading-[22px] leading-7 font-hanken-grotesk text-[var(--modal-text-heading-clr)] font-medium">
    {policyCriteria?.PolicyTemplate?.MinimumLength > 0 && (
      <li className={isMinMax ? "text-[var(--opps-text-color)]" : ""}>
        {policyRules[policyIndex++]}
      </li>
    )}
    {policyCriteria?.PolicyTemplate?.AlphaLength > 0 ? (
      <li className={isAlpha ? "text-[var(--opps-text-color)]" : ""}>
        {policyRules[policyIndex++]}
      </li>
    ) : (
      policyCriteria?.PolicyTemplate?.LowercaseLength > 0 && (
        <>
          <li className={isLowerCase ? "text-[var(--opps-text-color)]" : ""}>
            {policyRules[policyIndex++]}
          </li>
          {policyCriteria?.PolicyTemplate?.UppercaseLength < 0 ? (
            <li className={!isUpperCase ? "text-[var(--opps-text-color)]" : ""}>
              {policyRules[policyIndex++]}
            </li>
          ) : (
            <li className={isUpperCase ? "text-[var(--opps-text-color)]" : ""}>
              {policyRules[policyIndex++]}
            </li>
          )}
        </>
      )
    )}
    {policyCriteria?.PolicyTemplate?.NumericLength > 0 && (
      <li className={isNumeric ? "text-[var(--opps-text-color)]" : ""}>
        {policyRules[policyIndex++]}
      </li>
    )}
    {policyCriteria?.PolicyTemplate?.NonAlphaLength > 0 && (
      <li className={isSpecialChar ? "text-[var(--opps-text-color)]" : ""}>
        {policyRules[policyIndex++]}
      </li>
    )}
    <li className={password ? "text-[var(--opps-text-color)]" : ""}>
      {policyRules[policyIndex++]}
    </li>
    {/* <li className={password ? "text-[var(--opps-text-color)]" : ""}>
      {policyRules[policyIndex]}
    </li> */}
  </ul>
)}
     


          
        </div>

        <div className="flex justify-end items-center mt-20 mb-24">
          <button
            type="button"
            className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
              text-[var(--twofac-modal-btn-clr-disabled)] cursor-pointer flex items-center"
            onClick={handleSubmit(createPassword)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(createPassword)();
              }
            }}
          >
            {t("continue")}
            <img
              src={appThemeData.SignupNextArrow}
              className={`${
                signUpkudzuPlusTrue
                  ? ""
                  : " md:w-[17px] sm:w-[11px]  md:h-[17px] sm:h-[11px] w-[12px] h-[12px]"
              } ml-2`}
              alt=""
            />
          </button>
        </div>
      </Card>
      {isLoading && <Loader />}
    </div>
  );
};

export default CreatePassword;
